import React, { useState } from 'react';
import usePDPKeySellingPoints from 'data-hooks/usePDPKeySellingPoints';
import Placeholder from 'components/consumer/Placeholder';
import StandardModal from 'components/consumer/StandardModal';

import IconReturns from 'components/icons/iconReturns';
import IconMaterialsDesigned from 'components/icons/iconMaterialsDesigned';
import IconCalendar from 'components/icons/iconCalendar';
import IconDeliveryFlat from 'components/icons/iconDeliveryFlat';
import IconClock from 'components/icons/IconClock';
import iconPremiumDelivery from 'components/icons/iconPremiumDelivery';
import IconAffirmLogo from 'components/icons/iconAffirmLogo';
import PDPValuePropsModalV2 from './PDPValuePropsModalV2';

const ICON_MAP = {
  IconReturns,
  IconMaterialsDesigned,
  IconCalendar,
  IconDeliveryFlat,
  IconClock,
  iconPremiumDelivery,
  IconAffirmLogo,
};

const PDPKeySellingPointsV2 = () => {
  const { loading, data } = usePDPKeySellingPoints();
  const [activePanel, setActivePanel] = useState(null);

  if (loading) {
    return (
      <div className="flex flex-col justify-center mt-8 p-0 w-full">
        <ul className="items-center flex justify-center list-none m-0 p-0">
          {[0, 1, 2].map(idx => (
            <li
              className="items-center flex flex-col justify-center list-none m-0 p-0"
              key={`PDPKeySellingPointsV2__item${idx}`}
            >
              <div className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand [&_span]:max-[767px]:max-w-[90px]">
                <div className="flex items-center justify-center mb-2">
                  <Placeholder
                    type="round"
                    loading
                    style={{ height: 36, width: 36 }}
                  />
                </div>
                <span className="max-[767px]:max-w-[90px]">
                  <Placeholder
                    type="rect"
                    loading
                    style={{ height: 12, width: 120 }}
                  />
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center mt-8 p-0 w-full">
      <ul className="items-center flex justify-center list-none m-0 p-0">
        {data.map((item, index) => {
          const iconData = item.icon;
          const IconComponent = ICON_MAP[iconData.name];

          return IconComponent ? (
            <li
              className="items-center flex flex-col justify-center list-none m-0 p-0"
              key={`ksp-${item.id || index}`}
            >
              <button
                type="button"
                className="text-xs bg-transparent border-2 border-solid border-transparent cursor-pointer text-gray-light1 items-center flex flex-col px-2 py-0.5 m-0 text-center max-w-[33vw] !normal-case max-[767px]:flex-1 max-[767px]:leading-[unset] max-[767px]:p-0 max-[767px]:m-0 ml-5 last:mr-5 focus:text-brand hover:text-brand"
                onClick={() => setActivePanel(item)}
              >
                <div className="flex items-center justify-center mb-2">
                  <IconComponent
                    aria-hidden="true"
                    color="currentColor"
                    height={iconData.height || 26}
                    width={iconData.width || 26}
                  />
                </div>

                <span className="max-[767px]:max-w-[90px]">{item.label}</span>
              </button>
            </li>
          ) : null;
        })}
      </ul>
      {activePanel && (
        <StandardModal
          isOpen
          title={activePanel.label}
          icon={(() => {
            const Icon = ICON_MAP[activePanel.icon?.name];
            return Icon ? (
              <div className="[&_g]:stroke-[#fff]">
                <Icon width={25} height={30} color="#ffffff" />
              </div>
            ) : null;
          })()}
          onClose={() => {
            setActivePanel(null);
          }}
        >
          <PDPValuePropsModalV2 description={activePanel.description} />
        </StandardModal>
      )}
    </div>
  );
};

export default PDPKeySellingPointsV2;
